<template>
   <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-content class="bg_image">
        
      <v-container fluid fill-height>
        <v-layout align-end justify-center>
          <v-flex xs12 sm8 md4>
           <form-login @close="showLogin = false" v-show="!$router.currentRoute.query.token"></form-login>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
     </v-app>
</template>
<script>
import {
  mapActions
} from 'vuex'

export default {
  data: () => ({
      images1: [{
      	id: 1,
        title: 'Welkom',
        pattern: true, 
        path: 'img/background-blur.jpg'
      },{
      	id: 2,
        title: '',
        pattern: true, 
        path: 'img/background-blur.jpg'
      }],
     images: [{
      	id: 0,
      	pattern: true, 
        title: 'Nederlands Kennis Centrum',
        path: 'img/background-blur.jpg'
      },{
      	id: 1,
      	pattern: true, 
        title: 'ERP',
        path: 'http://lorempixel.com/1920/1080/business/1/'
      }, {
      	id: 2,
      	pattern: true, 
        title: 'CRM',
        path: 'http://lorempixel.com/1920/1080/business/3/'
      }, {
      	id: 3,
      	pattern: true, 
        title: 'HRM',
        path: 'http://lorempixel.com/1920/1080/business/4/'
      }, {
      	id: 4,
        pattern: true, 
        title: 'Software',
        path: 'http://lorempixel.com/1920/1080/business/6/'
      }, {
      	id: 5,
        pattern: true, 
        title: 'Nederlands Kennis Centrum',
        path: 'http://lorempixel.com/1920/1080/business/7/'
      }, {
      	id: 6,
        pattern: true, 
        title: '',
        path: 'http://lorempixel.com/1920/1080/business/9/'
      }]
  }),
  computed: {
    overlay(){
      if (this.$router.currentRoute.query.token) return true
      return false
    }
  },
  mounted () {
    console.log('LOGIN',this.$router.currentRoute)
    this.logout()
    
  },
  methods: {
     ...mapActions('auth', ['logout','login']),
  } 
};
</script>
<style>
  .bg_image {
    background: url(/img/background-blur.jpg) no-repeat;
    background-size: cover;
    background-position: center; 
    height:100%;
  }
</style>